import { types, getParent, type Instance } from 'mobx-state-tree';
import ObjectType from '../metamodel/object_type';
import { modelReference } from '../refHelper';

/**
 * A column in the OET.
 *
 * For the reference to the object type, we don't use types.reference directly,
 * but our custom wrapper. See '../refHelper.js' for the reason why.
 */
const OETColumn = types.model('OETColumn', {
  object: modelReference<typeof ObjectType>(ObjectType),
}).views((self) => ({
  // get the lowercased name of the object type
  get lowerCaseObjectName() {
    return self.object.name.toLowerCase()
  },
  // get the index of this column in the array of columns
  get index() {
    return getParent<IOETColumn[]>(self).indexOf(self as unknown as IOETColumn);
  },
  // get the id of the referenced object type
  get id() {
    return self.object.id;
  }
})).actions(() => ({
}));

export type IOETColumn = Instance<typeof OETColumn>;

export default OETColumn;
